import messages from 'modules/bookables/i18n'

export default {
  key: 'widget',
  messages: messages,
  routes: [],
  reducer: (state = {}) => state
}
